import { t } from '../../../../../i18n';

export const getClosedCaptionsLabel = label => `${label} (${t('player.closedCaption')})`;
